import React from "react";
import Table from "../../common/Table";

const PendingActions = () => {
  const columns = [
    {
      header: "Sales Order",
      width: 20,
    },
    {
      header: "Order Date",
      width: 20,
    },
    {
      header: "Customer PO",
      width: 20,
    },
    {
      header: "Order Status",
      width: 20,
    },
    {
      header: "Amount",
      width: 20,
    },
  ];
  return (
    <div className="tb1">
      <div className="flex-between mb1">
        <label>Pending Actions</label>
        <span>VIEW ALL</span>
      </div>
      <Table columns={columns} />
    </div>
  );
};

export default PendingActions;
